import { CenteredLoading, deviceCheck } from '@healthhub/react-ui';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router';

import { APP_STORE_URL } from '@shared/constants/constants';
import { ROOT_PATH } from '@shared/constants/paths';

import { PageNotFound } from '../../PageNotFound';

const TemporaryRedirect = () => {
  const [redirectCheckComplete, setRedirectCheckComplete] = useState(false);
  const [deepLinkCheckComplete, setDeepLinkCheckComplete] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const fetchRedirectMap = async () => {
      try {
        const response = await axios.get('/redirect/redirectMap.json');
        // Effect was torn down while the fetch was in flight; a newer run (or unmount) owns the outcome
        if (cancelled) return;

        const redirectConfig = response.data?.find(({ path, search }: { path: string; search?: string }) => {
          const matchedPath = matchPath({ caseSensitive: false, end: true, path }, location.pathname);

          if (matchedPath && search) {
            return location.search.includes(search);
          }

          return !!matchedPath;
        });

        if (redirectConfig) {
          if (redirectConfig.redirect.startsWith('https')) {
            window.location.replace(redirectConfig.redirect);
          } else {
            navigate(redirectConfig.redirect, { replace: true });
          }
          // Keep the loader up until the redirect replaces this route, so PageNotFound doesn't flash
          return;
        }
      } catch (error) {
        console.error('Error fetching redirect map:', error);
      }

      if (!cancelled) setRedirectCheckComplete(true);
    };
    fetchRedirectMap();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search, navigate]);

  useEffect(() => {
    const isDeepLinkPath = location.pathname.startsWith('/app/') || location.pathname === '/app';

    if (!isDeepLinkPath) {
      setDeepLinkCheckComplete(true);
      return;
    }

    if (deviceCheck.isIOS()) {
      window.location.href = APP_STORE_URL.ios;
    } else if (deviceCheck.isAndroid()) {
      window.location.href = APP_STORE_URL.android;
    } else {
      navigate(ROOT_PATH, { replace: true });
    }
  }, [location.pathname, navigate]);

  return redirectCheckComplete && deepLinkCheckComplete ? <PageNotFound /> : <CenteredLoading />;
};

export default TemporaryRedirect;
